import React, { Component, useEffect, useState } from "react";
import { getrequisitionForEdit, updateReq } from "app/services/paymentService";
import { Button, Modal } from "react-bootstrap";
import { Formik } from "formik";
import {
  RenderDateInput,
  RenderSelectInput,
  RenderTextArea,
  RenderTextInput,
} from "app/common/renderInput";
import * as yup from "yup";
import { getBankList } from "app/services/AdminServices/bankService";
import moment from "moment";
import { NotificationManager } from "react-notifications";

const validationModel = yup.object().shape({
  amount: yup.number().required("Please enter your amount"),
  referenceNo: yup.string().required("Please enter your Reference No"),
  requestDate: yup.string().required("Please enter Member type"),
  bankId: yup.string().required("Please enter Bank Id"),
  transactionDetails: yup.string().optional("Please enter Transaction Details"),
  transferMethod: yup.string().required("Please enter Transfer Method"),
  bankCharges: yup.string().required("Please enter Bank Charges"),
  remarks: yup.string().optional(),
});

function EditReq(props) {
  const item = {
    details: [],
    ReqId: 0,
    amount: 0,
    referenceNo: 0,
    requestDate: "",
    bankId: 0,

    transferMethod: "",
    bankCharges: "",
    bankList: [],
    paymentTypeList: [
      { value: "NEFT", label: "NEFT" },
      { value: "IMPS", label: "IMPS" },
      { value: "UPI", label: "UPI" },
      { value: "RTGS", label: "RTGS" },
      { value: "ONLINE", label: "ONLINE" },
    ],
    transactionDetails: "",
    remarks: "",
  };

  const [initialState, SetInitialState] = useState(item);
  const [bankState, SetBankState] = useState([]);
  const [ReqId, setReqId] = useState(0);
  const [details, setDetails] = useState(null);
  // const [details, setDetails] = useState([]);
  // async componentWillReceiveProps(nextProps, nextState) {
  // useEffect(() => {
  //   debugger;
  //   if (ReqId > 0 && item.ReqId != ReqId) {
  //     // this.setState({
  //     //   ReqId: nextProps.ReqId,
  //     // });

  //     const res = getrequisitionForEdit(ReqId);
  //     console.log(res);
  //     setDetails(res.data);
  //     // this.setState({
  //     //   details: res.data,
  //     // });
  //   }
  // }, []);

  // }

  // async componentDidMount() {
  //   await this.loadBankLists();
  // }

  useEffect(() => {
    if (props.ReqId > 0 && ReqId !== props.ReqId) {
      setReqId(props.ReqId);
      const fetchData = async () => {
        try {
          const res = await getrequisitionForEdit(props.ReqId);
          console.log(res);
          setDetails(res.data);
        } catch (error) {
          // Handle error if required
          console.log(error);
        }
      };

      fetchData();
    }
  }, [props.ReqId, ReqId]);
  const loadBankLists = async () => {
    const response = await getBankList();
    const bankData = response.data;
    const bankList = bankData.map((x, i) => {
      return {
        value: x.id,
        label: x.bankName,
      };
    });
    // debugger
    SetBankState(bankList);
    // this.setState({
    //   bankList,
    // });
  };
  useEffect(() => {
    loadBankLists();
  }, []);

  const handleSubmit = async (values) => {
    console.log(values);
    const response = await updateReq(values);
    console.log(response);
    if (response.status === "Success") {
      setTimeout(async () => {
        NotificationManager.success("Requisition updated successfully");
        await props.loadTransaction();
        document.getElementsByClassName("btn-close")[0].click();
      }, 800);
    } else {
      NotificationManager.danger("Sorry! Requisition failed.");
    }
  };

  return (
    <div
      className="modal fade"
      id="editReqPopup"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Edit Requisition
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            {details ? (
              <Formik
                initialValues={details}
                validationSchema={validationModel}
                onSubmit={handleSubmit}
                enableReinitialize={true}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  isValid,
                  dirty,
                  setFieldValue,
                }) => {
                  return (
                    <form
                      className="needs-validation"
                      onSubmit={handleSubmit}
                      noValidate
                    >
                      <div className="row">
                        <RenderTextInput
                          type="number"
                          name="amount"
                          display="Amount"
                          value={values.amount}
                          error={errors.amount}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.amount}
                          required
                        ></RenderTextInput>

                        <RenderTextInput
                          type="text"
                          name="referenceNo"
                          display="Reference No"
                          value={values.referenceNo}
                          error={errors.referenceNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.referenceNo}
                        ></RenderTextInput>
                      </div>

                      <div className="row">
                        <RenderDateInput
                          type="date"
                          display="Request Date"
                          name="requestDate"
                          value={
                            values.requestDate
                              ? new moment(values.requestDate).format(
                                  "YYYY-MM-DD"
                                )
                              : ""
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.requestDate}
                          touched={touched.requestDate}
                          required
                        ></RenderDateInput>

                        {/* <RenderTextInput
                          type="number"
                          display="Bank Id"
                          name="bankId"
                          value={values.bankId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.bankId}
                          touched={touched.bankId}
                          required
                        ></RenderTextInput> */}

                        <RenderSelectInput
                          name="bankId"
                          display="Bank List"
                          placeholder="Bank List"
                          value={values.bankId}
                          error={errors.bankId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.bankId}
                          items={bankState}
                          required
                        ></RenderSelectInput>
                      </div>

                      <div className="row">
                        <RenderTextInput
                          type="text"
                          display="Transaction Details"
                          name="transactionDetails"
                          value={values.transactionDetails}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.transactionDetails}
                          touched={touched.transactionDetails}
                          required
                        ></RenderTextInput>

                        <RenderSelectInput
                          display="Transfer Method"
                          name="transferMethod"
                          value={values.transferMethod}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.transferMethod}
                          touched={touched.transferMethod}
                          items={item.paymentTypeList}
                          required
                        ></RenderSelectInput>
                      </div>

                      <div className="row">
                        <RenderTextInput
                          type="number"
                          display="Bank Charges"
                          name="bankCharges"
                          value={values.bankCharges}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.bankCharges}
                          touched={touched.bankCharges}
                          required
                        ></RenderTextInput>
                      </div>
                      <div>
                        <RenderTextArea
                          name="remarks"
                          display="Remarks"
                          placeholder="Remarks"
                          onBlur={handleBlur}
                          value={values.remarks}
                          onChange={handleChange}
                          touched={touched.remarks}
                          error={errors.remarks}
                        ></RenderTextArea>
                      </div>

                      <div className="d-flex align-items-center justify-content-center mt-3">
                        <Button
                          className="mx-1"
                          variant="outline-primary"
                          type="submit"
                        >
                          Update
                        </Button>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </form>
                  );
                }}
              </Formik>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditReq;
